import { render, staticRenderFns } from "./checkupOpinion.vue?vue&type=template&id=06344b4e"
import script from "./checkupOpinion.vue?vue&type=script&lang=js"
export * from "./checkupOpinion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06344b4e')) {
      api.createRecord('06344b4e', component.options)
    } else {
      api.reload('06344b4e', component.options)
    }
    module.hot.accept("./checkupOpinion.vue?vue&type=template&id=06344b4e", function () {
      api.rerender('06344b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/checkupOpinion.vue"
export default component.exports